<span mat-dialog-title>{{ commentable ? commentable.getDisplayName() : 'Comment' }}</span>
<form [formGroup]="formGroup" (ngSubmit)="create()">
  <mat-dialog-content>
    <bt-form-errors></bt-form-errors>
    <bt-form-field>
      <mat-form-field color="accent" appearance="outline" class="comment-content">
        <mat-label>{{ "general.label.comment" | translate }}</mat-label>
        <textarea matInput rows="5" name="body" formControlName="body" required style="resize: none"></textarea>
      </mat-form-field>
      <bt-field-errors></bt-field-errors>
    </bt-form-field>
    @if (isError) {
      <mat-label class="error-message">{{ "tasks.general.message" | translate }}</mat-label>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button [matDialogClose]="">{{ "general.action.cancel" | translate }}</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="formGroup.invalid || (commentable ?? null) === null || isError">{{ "general.action.save" | translate }}</button>
  </mat-dialog-actions>
</form>
